var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidenav-container"},[(_vm.toggleSidebar)?_c('div',{staticClass:"backdrop",on:{"click":function($event){return _vm.$store.dispatch('toggleSidebar')}}}):_vm._e(),_c('transition',{attrs:{"name":"slide-side"}},[(_vm.toggleSidebar)?_c('div',{staticClass:"sidenav"},[_c('HeaderNav'),_c('MenuSide')],1):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }